import React from 'react';
import GameSession from '../../Common/GameSession';

const PlayerGameSession = ({ playerID }) => {
    return <GameSession forPlayer={true} playerID={playerID} />
};

export default PlayerGameSession;
